export type ProgressMutation<Value> = Promise<Value> | Value;

export interface ProgressMutationObserver<Value> {
  readonly complete: (value: Value) => void;
  readonly failed: () => void;
  readonly pending: () => void;
}

export const observeProgressMutation = <Value>(
  mutation: ProgressMutation<Value>,
  observer: ProgressMutationObserver<Value>,
): void => {
  if (mutation instanceof Promise) {
    observer.pending();
    void mutation.then(observer.complete, observer.failed);
    return;
  }
  observer.complete(mutation);
};
